import Notification from "src/components/Notification/Notification";
import { Switch } from "@k8slens/lds";
import { useBusiness } from "src/hooks/useBusiness";
import styles from "./AutoJoinSwitch.module.css";
import { useContext } from "react";
import { BusinessContext } from "./Base";

export const AutoJoinSwitch = ({ disabled }: { disabled: boolean }) => {
  const { businessId, business } = useContext(BusinessContext);
  const { updateBusiness, updatingBusiness, errorUpdatingBusiness } = useBusiness(businessId);
  const checked = Boolean(business?.ssoAutoJoin);

  return (
    <div className={styles.autoJoinSwitchWrapper}>
      <section className="self-center">
        <h3 className="lds-h3">Automatically assign seats</h3>
        <p className="leading-normal">
          Enable automatic seat assignment to streamline the process of assigning seats to users logging in via SSO.
          Without this feature enabled, SSO will be limited to authentication purposes, and users will appear on the
          user list as members without assigned seats. Manual seat assignment will then be required.
        </p>
        {errorUpdatingBusiness ? (
          <Notification level="error" message={errorUpdatingBusiness.message} type="closable" className="my-5" />
        ) : null}
      </section>
      <Switch
        className={styles.switch}
        disabled={disabled || updatingBusiness}
        title={disabled ? "Save SSO settings before enabling automatically assign seats" : ""}
        onChange={(newchecked) => {
          if (!business) {
            return;
          }
          updateBusiness({
            ssoAutoJoin: newchecked,
          });
        }}
        checked={checked}
      />
    </div>
  );
};
